import * as React from 'react';
import { styles } from './styles';
import { Column } from './components/Column';
import { cx } from 'emotion';
import { SpatialOption } from '@joykit/variables/space';
import { variables } from './variables';
import { ColumnGap } from './types';

export interface ColumnsProps {
  children: React.ReactNode;
  className?: string;
  /**
   * Each column has a **gap** equal to a value defined in the **spatial system**, which has a default value of `1rem`.
   * Since the gap is on each side of a column, the gap between two adjacent columns will be twice the value of `spatialValuesInRem[columnGap]`,
   * or `spatialValuesInRem[SpatialOptions.default]` by default (2rem).
   */
  columnGap: ColumnGap;

  /**
   * While you can start a new line by closing a `columns` and starting a new one. You can set `multine=true` to
   * allow the component to handle more components than would fit in a single row.
   */
  multiline: boolean;

  /**
   * Horizontally center the children.
   */
  centered: boolean;

  /**
   * By default, columns are activated from `tablet` onwards. To have columns work on mobile,
   * pass `true`.
   */
  stackOnMobile: boolean;
}

class Columns extends React.Component<ColumnsProps> {
  static defaultProps = {
    columnGap: SpatialOption.default,
    multiline: false,
    centered: false,
    stackOnMobile: false
  };

  static Column = Column;

  render() {
    const className = cx(styles.container(this.props), variables.COLUMNS_CLASS_NAME, this.props.className);
    return <div className={className}>{this.renderChildren()}</div>;
  }

  private renderChildren = () => {
    return React.Children.map(this.props.children, (child, i) => {
      if (React.isValidElement(child) && (child as any).type.displayName) {
        return React.cloneElement(child as JSX.Element, {
          columnGap: this.props.columnGap
        });
      }
      return child;
    });
  };
}

export { Columns };
